/* eslint-disable prefer-rest-params */
export default function stickyMeta() {
  const postMeta = document.querySelector('.wp-block-column .post-meta');
  function checkMetaPosition() {
    if (postMeta) {
      const eleParentPosition = postMeta.parentElement.getBoundingClientRect();
      const elePrentWidth = postMeta.parentElement.offsetWidth;
      const eleHeight = postMeta.offsetHeight;
      const eleGrandparent = postMeta.parentElement.parentElement;
      const eleGrandparentHeight = eleGrandparent.offsetHeight;

      // If the post-meta is greater or same height as container, no need to make it stick.
      if (eleHeight >= eleGrandparentHeight) {
        return;
      }

      postMeta.style.width = `${elePrentWidth}px`;

      if (eleParentPosition.top < 122) {
        postMeta.classList.add('post-meta-sticky');
      } else {
        postMeta.classList.remove('post-meta-sticky');
      }

      const bottomOffset = postMeta.offsetHeight + 120;
      if (eleParentPosition.bottom < bottomOffset) {
        postMeta.parentElement.classList.add('post-meta-lock');
      } else {
        postMeta.parentElement.classList.remove('post-meta-lock');
      }
    }
    window.addEventListener('resize', () => {
      if (postMeta) {
        const elePrentWidth = postMeta.parentElement.offsetWidth;
        postMeta.style.width = `${elePrentWidth}px`;
      }
    });
  }
  function debounce(func, wait = 10, immediate = true) {
    let timeout;
    return function debouncer() {
      const context = this;
      const args = arguments;
      const later = function later() {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };
      const callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  }

  window.addEventListener('scroll', debounce(checkMetaPosition));
}
